module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_01-23d6e406865c7d1fe315df2575fc8bfc.png";